// extracted by mini-css-extract-plugin
export var link = "_qk-0";